// Prevent the default redirect after successful registration

// $(document).ready(function() {
//     $('button#Subscribe').submit(function(e) {
//         e.preventDefault();
//         // Set a timeout for the redirect after 30 seconds
//         setTimeout(function() {
//             // Replace 'your-redirect-url' with the actual URL where you want to redirect the user
//                     $('#ContactFooter-success').text('Thank you for signing up!');
//         }, 3000); // 30 seconds delay
//     });
// });


// if(jQuery(window).width() < 750){
// $('.main-cart-details .cart-item').each(function(){
//       $(this).find('td.cart-item__media~td').wrapAll('<div class="new" />');
//   });
// }


jQuery(document).ready(function($) {
    $('.product-form__input input[type=radio]').click(function() {
        if ($(this).hasClass('disabled')) {
            $('body').addClass('soldout');
        } else {
            $('body').removeClass('soldout');
        }
    });
});



  function handlePaginationChange() {
var currentUrl = window.location.href;

// Define the new parameter and its value
var selectElement = document.getElementById('paginationDropdown');
var newParameter = 'page';
var paramValue = selectElement.options[selectElement.selectedIndex].value;

// Check if the URL already contains a query string
if (currentUrl.includes('?')) {
  // If it does, append the new parameter
  currentUrl += '&' + encodeURIComponent(newParameter) + '=' + encodeURIComponent(paramValue);
} else {
  // If it doesn't, create a new query string
  currentUrl += '?' + encodeURIComponent(newParameter) + '=' + encodeURIComponent(paramValue);
}
    // var selectElement = document.getElementById('paginationDropdown');
    // var selectedPage = selectElement.options[selectElement.selectedIndex].value;
    window.location.href = currentUrl;

console.log(currentUrl);
  }

  // document.getElementById("ContactForm").addEventListener("submit", function(e) {
  //   e.preventDefault(); // Prevents the default form submission behavior

  //   fetch('/contact', {
  //     method: 'POST',
  //     body: new FormData(e.target)
  //   })
  //   .then(response => {
  //     if (response.ok) {
  //       document.getElementById("ContactForm").style.display = 'none'; // Hide the form
  //       document.getElementById("successMessage").style.display = 'block'; // Show the success message
  //     } else {
  //       throw new Error('Network response was not ok');
  //     }
  //   })
  //   .catch(error => {
  //     console.error('There has been a problem with your fetch operation:', error);
  //   });
  // });

$('.ssw-stars.ssw-stars-large').click(function() {
$('button#pills-profile-tab,div#pills-profile').addClass('active');
$('div#pills-profile').addClass('show');
$('div#flush-collapseTwo').addClass('show');  
$('[data-bs-target="#flush-collapseTwo"]').removeClass('collapsed');  
  
$('button#pills-home-tab,div#pills-home').removeClass('active');
$('div#pills-home').removeClass('show');     
    
});

// if ($("[aria-label='Page 3']").hasClass("pagination__item--current")) {
//   $('.fifty-product').addClass('only-fifty');
//   $("ul.pagination__list li.number-list:nth-child(n+4)").nextAll().hide();
// }

// $(document).on('click','[aria-label="Page 3"]', function() {
//   $('.fifty-product').addClass('only-fifty');
//   $("ul.pagination__list li.number-list:nth-child(n+4)").nextAll().hide();
// });

// $(".fifty-product li.grid__item").slice(0, 20).show();

$(".latest-blog-sec .grid__item").slice(0, 8).show();

$("body").on('click touchstart', '.latest-blog-sec  .see-more .btn', function (e) {

  e.preventDefault();

  $(".latest-blog-sec .grid__item:hidden").slice(0, 4).slideDown();

  if ($(".latest-blog-sec .grid__item:hidden").length == 0 ) {
      $(".latest-blog-sec .see-more .btn").css('visibility', 'hidden');
  }
});

  if ($(".latest-blog-sec .grid__item").length <= 8 ) {
      $(".latest-blog-sec .see-more .btn").css('visibility', 'hidden');
  }

$(document).ready(function(){

var i = 0;
$('.kids-landing-page ul,.collection-kids #product-grid, .product-kids .flickity-viewport,.product-kids,.product-kids ul ').find('.grid__item, .carousel-cell, .recently-viewed-grid-item, .product--thumbnail_slider button.thumbnail').each(function(i){

var num = (i%8) + 1; // mod function - returns the remainder

$(this)

.addClass('bg-' + num )

});

// var matched = $(".section-template--21521842110772__cart-items-padding .cart-items tbody tr");
// $('.total-items').text('(' + matched.length + ' Items)');
  
jQuery('.sort-per-page select.num').on('change', function(){
      window.location.replace(jQuery(this).val());
});

  jQuery('svg.icon-account').click(function() {
    jQuery('.dropdown').slideToggle();
  });
  jQuery('.close').click(function(){
    jQuery('.announcement-bar-section').slideUp();
  })

// $('.show-more').click(function(){
//     // $('.metafield-rich_text_field p:nth-child(n+4) ~ *').slideToggle(1000);
//     var txt = $('.metafield-rich_text_field p:nth-child(n+4) ~ *').is(':visible') ? 'Show More' : 'Show Less';
//     $(this).text(txt);
//     $('.metafield-rich_text_field p:nth-child(n+4) ~ *').slideToggle(1000);
// }); 

jQuery('.review-tab').after($('div#ssw-widget-recommends-html'));

// $('.product__image-slider .flickity-lazyloaded').lightzoom({
//   zoomPower   : 2,
//   glassSize   : 100
// });

$(document).on('click','button#CartDrawer-Checkout',function(e){
 e.preventDefault();
window.location.href = '/cart';
});

if(jQuery(window).width() < 1025){
        jQuery('.mob-review-tab').after($('div#ssw-widget-recommends-html'));
}



mobileOnlySlider(".mob-slider", true, false, 750);

function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
  var slider = $($slidername);
  var settings = {
    mobileFirst: true,
    dots: false,
    arrows: true,
    centerMode: true,
    centerPadding:'50px',
    responsive: [
      {
        breakpoint: $breakpoint,
        settings: "unslick"
      }
    ]
  };

  slider.slick(settings);

  $(window).on("resize", function () {
    if ($(window).width() > $breakpoint) {
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
}

   
});



$(function () {

$(".kids-landing-page .grid--2-col-tablet-down .grid__item").slice(0, 12).show();

$("body").on('click touchstart', '.kids-landing-page .see-more .btn', function (e) {

  e.preventDefault();

  $(".kids-landing-page .grid--2-col-tablet-down .grid__item:hidden").slice(0, 4).slideDown();

  if ($(".kids-landing-page .grid--2-col-tablet-down .grid__item:hidden").length == 0) {
      $(".kids-landing-page .see-more .btn").css('visibility', 'hidden');
  }
});
  if ($(".kids-landing-page .grid--2-col-tablet-down .grid__item").length <= 12) {
      $(".kids-landing-page .see-more .btn").css('visibility', 'hidden');
  }


$(".upcoming-events .event-grid").slice(0, 4).show();

$("body").on('click touchstart', '.see-more .btn', function (e) {

  e.preventDefault();

  $(".upcoming-events .event-grid:hidden").slice(0, 4).slideDown();

  if ($(".upcoming-events .event-grid:hidden").length == 0) {
      $(".upcoming-events .see-more .btn").css('visibility', 'hidden');
  }

});
  if ($(".upcoming-events .event-grid").length <= 4) {
      $(".upcoming-events .see-more .btn").css('visibility', 'hidden');
  }

});



$(function ()
{
    $('.lbts-add-to-cart-bar').wrap('<div id="sticky-cart"></div>');

$('.cart main#MainContent').wrap('<div class = "page-width"></div>')
});
const $rootSingle = $('.cSlider--single');
const $rootNav = $('.cSlider--nav');

 $rootSingle.slick({
	slide: '.cSlider__item',
 	slidesToShow: 1,
 	slidesToScroll: 1,
 	arrows: true,
 	fade: true,
 	adaptiveHeight: true,
 	infinite: true,
	useTransform: true,
 	speed: 1000,
 	cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
 });

 $rootNav.on('init', function(event, slick) {
 		$(this).find('.slick-slide.slick-current').addClass('is-active');
 	})
 	.slick({
	 	slide: '.cSlider__item',
 		slidesToShow: 3,
 		slidesToScroll: 1,
 		dots: false,
        arrows:false,
        vertical: true,
        speed:0,
 		focusOnSelect: false,
 		infinite: true,
 		responsive: [{
 			breakpoint: 1024,
 			settings: {
 				slidesToShow: 3,
 				slidesToScroll: 1,
 			}
 		}, {
 			breakpoint: 980,
 			settings: {
              arrows: false,
			}
 		}, {
 			breakpoint: 767,
 			settings: {
		}
 		}]
 	});

 $rootSingle.on('afterChange', function(event, slick, currentSlide) {
 	$rootNav.slick('slickGoTo', currentSlide);
 	$rootNav.find('.slick-slide.is-active').removeClass('is-active');
 	$rootNav.find('.slick-slide[data-slick-index="' + currentSlide + '"]').addClass('is-active');
 });

 $rootNav.on('click', '.slick-slide', function(event) {
 	event.preventDefault();
 	var goToSingleSlide = $(this).data('slick-index');

 	 $rootSingle.slick('slickGoTo', goToSingleSlide);
 });


$('.gallery-row').slick({
  arrows: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 3,
  slidesToScroll: 1,
  variableWidth: true,
  centerPadding: '60px',
  responsive: [{
 			breakpoint: 1024,
 			settings: {
 				slidesToShow: 3,
 				slidesToScroll: 1,
 			}
 		}, {
 			breakpoint: 980,
 			settings: {
			}
 		}, {
 			breakpoint: 767,
 			settings: {
              centerMode: true,
                  centerPadding: '70px',
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: false,
		}
 		}]
});

$('.testi-row').slick({
  arrows: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [{
 			breakpoint: 1024,
 			settings: {
 				slidesToShow: 2,
 				slidesToScroll: 1,
 			}
 		}, {
 			breakpoint: 980,
 			settings: {
			}
 		}, {
 			breakpoint: 767,
 			settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: true,
              arrows: false,
		}
 		}]
});


// $('.cSlider--nav .cSlider__item.slick-slide.slick-current.slick-active').hide();



// Rating
$(document).ready(function() {

  var faverageRating1 = $('.mecca-featured-result-content').find('.averageRating1').data('rating');
  var faverageRating2 = $('.mecca-featured-result-content').find('.averageRating2').data('rating');
  var faverageRating3 = $('.mecca-featured-result-content').find('.averageRating3').data('rating');

  var laverageRating1 = $('.mecca-latest-result-content').find('.averageRating1').data('rating');
  var laverageRating2 = $('.mecca-latest-result-content').find('.averageRating2').data('rating');
  var laverageRating3 = $('.mecca-latest-result-content').find('.averageRating3').data('rating');

  var paverageRating1 = $('.mecca-popular-result-content').find('.averageRating1').data('rating');
  var paverageRating2 = $('.mecca-popular-result-content').find('.averageRating2').data('rating');
  var paverageRating3 = $('.mecca-popular-result-content').find('.averageRating3').data('rating');
  
  updateRating1(faverageRating1, ".mecca-featured-result-content");
  updateRating2(faverageRating2, ".mecca-featured-result-content");
  updateRating3(faverageRating3, ".mecca-featured-result-content");

  updateRating1(laverageRating1, ".mecca-latest-result-content");
  updateRating2(laverageRating2, ".mecca-latest-result-content");
  updateRating3(laverageRating3, ".mecca-latest-result-content");  

  updateRating1(paverageRating1, ".mecca-popular-result-content");
  updateRating2(paverageRating2, ".mecca-popular-result-content");
  updateRating3(paverageRating3, ".mecca-popular-result-content");

  $("#mecca-featured-products .swiper-slide").on("click", function() {
    // Retrieve the data-info attribute value
    var info = $(this).data("info");
    var desc = $(this).data("desc");
    var price = $(this).data("price");
    var compareprice = $(this).data("compareprice");
    var prodlink = $(this).data("prodlink");
    var prodimg = $(this).data("prodimg");
    var ratingvalue = $(this).data("ratingvalue");
    var authorname = $(this).data("authorname");
    
    $(".mecca-featured-result-content h3").text(info);
    $(".mecca-featured-result-content p.product-desc").text(desc);
    $(".mecca-featured-result-content p.product-price span").text(price);
    $(".mecca-featured-result-content p.product-price del").text(compareprice);
    $(".mecca-featured-result-content .button").attr('href', prodlink);
    $(".mecca-featured-result-img img").attr('src', prodimg);
    $(".mecca-featured-result-content h5.prod-author-name").html(authorname);
    updateRating1(ratingvalue, ".mecca-featured-result-content");
    updateRating2(ratingvalue, ".mecca-featured-result-content");
    updateRating3(ratingvalue, ".mecca-featured-result-content");

  });

  $("#mecca-latest-products .swiper-slide").on("click", function() {
    // Retrieve the data-info attribute value
    var info = $(this).data("info");
    var desc = $(this).data("desc");
    var price = $(this).data("price");
    var compareprice = $(this).data("compareprice");
    var prodlink = $(this).data("prodlink");
    var prodimg = $(this).data("prodimg");
    var ratingvalue = $(this).data("ratingvalue");
    var authorname = $(this).data("authorname");
    
    $(".mecca-latest-result-content h3").text(info);
    $(".mecca-latest-result-content p.product-desc").text(desc);
    $(".mecca-latest-result-content p.product-price span").text(price);
    $(".mecca-latest-result-content p.product-price del").text(compareprice);
    $(".mecca-latest-result-content .button").attr('href', prodlink);
    $(".mecca-latest-result-img img").attr('src', prodimg);
    $(".mecca-latest-result-content h5.prod-author-name").html(authorname);
    updateRating1(ratingvalue, ".mecca-latest-result-content");
    updateRating2(ratingvalue, ".mecca-latest-result-content");
    updateRating3(ratingvalue, ".mecca-latest-result-content");

  });

  $("#mecca-popular-products .swiper-slide").on("click", function() {
    // Retrieve the data-info attribute value
    var info = $(this).data("info");
    var desc = $(this).data("desc");
    var price = $(this).data("price");
    var compareprice = $(this).data("compareprice");
    var prodlink = $(this).data("prodlink");
    var prodimg = $(this).data("prodimg");
    var ratingvalue = $(this).data("ratingvalue");
    var authorname = $(this).data("authorname");
    
    $(".mecca-popular-result-content h3").text(info);
    $(".mecca-popular-result-content p.product-desc").text(desc);
    $(".mecca-popular-result-content p.product-price span").text(price);
    $(".mecca-popular-result-content p.product-price del").text(compareprice);
    $(".mecca-popular-result-content .button").attr('href', prodlink);
    $(".mecca-popular-result-img img").attr('src', prodimg);
    $(".mecca-popular-result-content h5.prod-author-name").html(authorname);
    updateRating1(ratingvalue, ".mecca-popular-result-content");
    updateRating2(ratingvalue, ".mecca-popular-result-content");
    updateRating3(ratingvalue, ".mecca-popular-result-content");

  });

  // Function to update the rating display
  function updateRating1(rating, result) {
      $(result).find('.star-rating-1 .star').css('color', 'lightgray');
      for (var i = 0; i < rating; i++) {
          $(result).find('.star-rating-1 .star').eq(i).css('color', 'gold');
      }
  }
  function updateRating2(rating, result) {
      $(result).find('.star-rating-2 .star').css('color', 'lightgray');
      for (var i = 0; i < rating; i++) {
          $(result).find('.star-rating-2 .star').eq(i).css('color', 'gold');
      }
  }
  function updateRating3(rating, result) {
      $(result).find('.star-rating-3 .star').css('color', 'lightgray');
      for (var i = 0; i < rating; i++) {
          $(result).find('.star-rating-3 .star').eq(i).css('color', 'gold');
      }
  }

  $('.mobile-star-rating').each(function() {
        var $starRating = $(this);
        var productId = $starRating.data('product-id');
        var rating = parseFloat($('.mobile-average-rating[data-product-id="' + productId + '"]').data('rating'));

        $starRating.find('.star').css('color', 'lightgray');
        for (var i = 0; i < rating; i++) {
            $starRating.find('.star').eq(i).css('color', 'gold');
        }
    });
  $('.prodRating').each(function() {
        var $starRating = $(this);
        var productId = $starRating.data('product-id');
        var rating = parseFloat($('.prodRatingValue[data-product-id="' + productId + '"]').data('rating'));
        console.log($starRating);
        $starRating.find('.star').css('color', 'lightgray');
        for (var i = 0; i < rating; i++) {
            $starRating.find('.star').eq(i).css('color', 'gold');
        }
    });
  

  $('.recently-star-rating').each(function() {
        var $starRating = $(this);
        var productId = $starRating.data('product-id');
        var rating = parseFloat($('.recently-average-rating[data-product-id="' + productId + '"]').data('rating'));

        $starRating.find('.star').css('color', 'lightgray');
        for (var i = 0; i < rating; i++) {
            $starRating.find('.star').eq(i).css('color', 'gold');
        }
    });
  
$('.mob-slider-new').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '60px',
    arrows: true,
    autoplay: true,
    infinite: true,
    // fade: true,
    // asNavFor: '.txt-wrapper',
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 520,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 360,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }
    ]
});

$('.mob-slider-new1').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '60px',
    arrows: true,
    autoplay: true,
    infinite: true,
    // fade: true,
    // asNavFor: '.txt-wrapper',
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 520,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 360,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }
    ]
});

$('.mob-slider-new2').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '60px',
    arrows: true,
    autoplay: true,
    infinite: true,
    // fade: true,
    // asNavFor: '.txt-wrapper',
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 520,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 360,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }
    ]
});

// $('.txt-wrapper').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     asNavFor: '.mob-img-slider',
//     arrows: true,
//     autoplay: true,
//     dots: false,
//     // centerMode: true,
//     focusOnSelect: true,
//     responsive: [
//         {
//             breakpoint: 1024,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//                 infinite: true,
//                 dots: true
//             }
//         },
//         {
//             breakpoint: 600,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1
//             }
//         },
//         {
//             breakpoint: 480,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//                 infinite: true,
//                 adaptiveHeight: true,
//             }
//         }
//     ]
// });

// $('.mob-img-slider1').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     centerMode: true,
//     centerPadding: '70px',
//     arrows: true,
//     autoplay: true,
//     infinite: true,
//     // fade: true,
//     asNavFor: '.txt-wrapper1',
//     responsive: [
//         {
//             breakpoint: 1024,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//                 infinite: true,
//                 dots: true
//             }
//         },
//         {
//             breakpoint: 600,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//             }
//         },
//         {
//             breakpoint: 520,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//                 centerPadding: '90px',
//             }
//         },
//         {
//             breakpoint: 360,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//                 centerPadding: '70px',
//             }
//         }
//     ]
// });

// $('.txt-wrapper1').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     asNavFor: '.mob-img-slider1',
//     arrows: true,
//     autoplay: true,
//     dots: false,
//     // centerMode: true,
//     focusOnSelect: true,
//     responsive: [
//         {
//             breakpoint: 1024,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//                 infinite: true,
//                 dots: true
//             }
//         },
//         {
//             breakpoint: 600,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1
//             }
//         },
//         {
//             breakpoint: 480,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//                 infinite: true,
//                 adaptiveHeight: true,
//             }
//         }
//     ]
// });

// $('.mob-img-slider2').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     centerMode: true,
//     centerPadding: '70px',
//     arrows: true,
//     autoplay: true,
//     infinite: true,
//     // fade: true,
//     asNavFor: '.txt-wrapper2',
//     responsive: [
//         {
//             breakpoint: 1024,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//                 infinite: true,
//                 dots: true
//             }
//         },
//         {
//             breakpoint: 600,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//             }
//         },
//         {
//             breakpoint: 520,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//                 centerPadding: '90px',
//             }
//         },
//         {
//             breakpoint: 360,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//                 centerPadding: '70px',
//             }
//         }
//     ]
// });

// $('.txt-wrapper2').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     asNavFor: '.mob-img-slider2',
//     arrows: true,
//     autoplay: true,
//     dots: false,
//     // centerMode: true,
//     focusOnSelect: true,
//     responsive: [
//         {
//             breakpoint: 1024,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//                 infinite: true,
//                 dots: true
//             }
//         },
//         {
//             breakpoint: 600,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1
//             }
//         },
//         {
//             breakpoint: 480,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//                 infinite: true,
//                 adaptiveHeight: true,
//             }
//         }
//     ]
// });


  const swiper = new Swiper("#tab1 .swiper", {
      slidesPerView: 1,
      direction: "horizontal",
      loop: true,
      speed: 500,
      effect: 'slide',
      allowTouchMove: false,
  });
  const swiper1 = new Swiper("#tab2 .swiper", {
      slidesPerView: 1,
      direction: "horizontal",
      loop: true,
      speed: 500,
      effect: 'slide',
      allowTouchMove: false,
  });
  const swiper2 = new Swiper("#tab3 .swiper", {
      slidesPerView: 1,
      direction: "horizontal",
      loop: true,
      speed: 500,
      effect: 'slide',
      allowTouchMove: false,
  });


  if (window.innerWidth < 768) {
      swiper[1].params.spaceBetween = 10;
      swiper[1].params.centeredSlides = 1;
      swiper[1].params.slidesPerView = 'auto';
      swiper[1].update()
  }
  if (window.innerWidth < 768) {
      swiper1[1].params.spaceBetween = 10;
      swiper1[1].params.centeredSlides = 1;
      swiper1[1].params.slidesPerView = 'auto';
      swiper1[1].update()
  }
  if (window.innerWidth < 768) {
      swiper2[1].params.spaceBetween = 10;
      swiper2[1].params.centeredSlides = 1;
      swiper2[1].params.slidesPerView = 'auto';
      swiper2[1].update()
  }


  let sliderLength = swiper[0].slides.length - 1;
  let sliderIndex = swiper[0].activeIndex;


  function moveSlider(slideIndex) {
      for (let index = 0; index < swiper.length; index++) {
          const currentSwiper = swiper[index];
          currentSwiper.slideTo(slideIndex);
      }
  }

  $("div#tab1 .slider-prev-btn").on("click", function () {
      if (sliderIndex <= 0) {
          return;
      }
      sliderIndex--;
      moveSlider(sliderIndex);
  });

  $("div#tab1 .slider-next-btn").on("click", function () {
      if (sliderIndex >= sliderLength) {
          return;
      }
      sliderIndex++;
      moveSlider(sliderIndex);
});



  let sliderLength1 = swiper1[0].slides.length - 1;
  let sliderIndex1 = swiper1[0].activeIndex;

  function moveSlider1(slideIndex1) {
      for (let index = 0; index < swiper1.length; index++) {
          const currentSwiper1 = swiper1[index];
          currentSwiper1.slideTo(slideIndex1);
      }
  }

  $("div#tab2 .slider-prev-btn").on("click", function () {
      if (sliderIndex1 <= 0) {
          return;
      }
      sliderIndex1--;
      moveSlider1(sliderIndex1);
  });

  $("div#tab2 .slider-next-btn").on("click", function () {
      if (sliderIndex1 >= sliderLength1) {
          return;
      }
      sliderIndex1++;
      moveSlider1(sliderIndex1);
});


  let sliderLength2 = swiper2[0].slides.length - 1;
  let sliderIndex2 = swiper2[0].activeIndex;

  function moveSlider2(slideIndex2) {
      for (let index = 0; index < swiper2.length; index++) {
          const currentSwiper2 = swiper2[index];
          currentSwiper2.slideTo(slideIndex2);
      }
  }

  $("div#tab3 .slider-prev-btn").on("click", function () {
      if (sliderIndex2 <= 0) {
          return;
      }
      sliderIndex2--;
      moveSlider2(sliderIndex2);
  });

  $("div#tab3 .slider-next-btn").on("click", function () {
      if (sliderIndex2 >= sliderLength2) {
          return;
      }
      sliderIndex2++;
      moveSlider2(sliderIndex2);
});

});